function scrollToItem() {
	$('.used-list .tabs').animate({scrollLeft: $('.used-list .tabs .tabs-item.active').position().left - 40});
}

scrollToItem();